import { Controller } from 'stimulus';
import { templateContent } from '@/js/util';

export default class extends Controller {
  static values = { template: String };

  open() {
    const template = document.getElementById(this.templateValue);

    if (!template) {
      throw new Error(`render Questionnaires::DuplicatingModal to open #${this.templateValue}`);
    }

    document.body.append(templateContent(template));
  }
}
